module.exports = __webpack_public_path__ + "static/media/calendar.b63e7f28.png";